import { get } from "../../xhr/api";

// export const get_tax_appeals = (data, pageNum, filter) => {
//   return get(
//     "api/tax-appeal/list?page=" +
//       pageNum +
//       "&request_number=" +
//       filter.request_number +
//       "&appeal_type_id=" +
//       filter.appeal_type_id +
//       "&from_date=" +
//       filter.from_date +
//       "&to_date=" +
//       filter.to_date +
//       "&request_status=" +
//       filter.status +
//       "&per_page=" +
//       filter.per_page,
//     {},
//     true
//   );
// };

export const get_tax_appeals = (pageNum, filter) => {
  const queryParams = new URLSearchParams();

  queryParams.append("page", pageNum);

  Object.entries(filter).forEach(([key, value]) => {
    if (
      value !== null &&
      value !== undefined &&
      value !== "" &&
      !(typeof value === "string" && value.trim() === "")
    ) {
      queryParams.append(key, value);
    }
  });

  return get(`api/tax-appeal/list?${queryParams.toString()}`, {}, true);
};
